<template>
  <div style="margin: 0 16px;">
    <div style="padding-bottom: 16px; display: flex; align-items: center; border-bottom: 1px solid #ededed;">
<!--      手机：-->
<!--      <el-input type="search" v-model="phone" placeholder="请输入手机号" :maxlength="11" style="margin-right: 8px; width: 16em">-->
<!--        <template #prefix>-->
<!--          <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>-->
<!--        </template>-->
<!--      </el-input>-->
      <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
      <el-checkbox v-model="checked" style="margin-left: 8px;">本店客户</el-checkbox>
      <el-button type="primary" @click="getUserList" style="margin-left: 16px">查询</el-button>
      <el-button  @click="reSet" style="margin-left: 8px">重置</el-button>
<!--      <el-button  @click="getUserList">全部</el-button>-->
    </div>

    <div class="user-list" v-if="userList.length > 0">
      <div v-for="(item, index) of userList" :key="index" class="user-list-item" :class="[item.check?'active':'']" @click="select(item)">
        <div class="item-top">
<!--          <UserInfo :userId="item.id" :row="item" showList="name,sex,phone" />-->
          <p>主人：{{item.name}}</p>
          <p>手机：<span style="color: #409eff">{{item.phone}}</span></p>
          <p>门店：{{item.shopName}}</p>
        </div>
        <div v-if="item.petList.length > 0">
          <div v-for="(item, index) of item.petList" :key="index" class="item-pet">
            <div class="pointer"></div>
            <div>{{item.petBreedColorName}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</div>
          </div>
        </div>
        <div v-else class="noPet">
          <div class="pointer"></div>
          <div>暂未添加宠物</div>
        </div>
      </div>
    </div>
    <div v-else style="margin-top: 100px">
      <el-empty image-size="100" description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import {getFormData } from "@/api/api"
import {getUserInfo, listShopUser} from "@/api/url";
import UserInfo from "@/components/User/userInfo"
import SearchComponents from "@/components/SearchComponents";
export default {
  name: "UserListDialog",
  components: {UserInfo, SearchComponents},
  props: {
    value: Object
  },
  data() {
    return {
      shopId: this.value.shopId,
      userList: [],
      phone: '',

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '宠物名称', value : 3},
      ],
      searchType: 1,
      searchValue: '',

      checked: true,

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    reSet() {
      this.searchValue = ''
      this.checked = true
      this.getUserList()
    },


    getUserList() {
      let param = {}
      param['shopId'] = !this.checked?0:this.shopId
      param['searchType'] = this.searchType
      param['searchValue'] = this.searchValue
      getFormData(listShopUser, param).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.userList = []
          this.userList = data.data
          this.userList.map(item => {
            item.check = false
          })
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    // search() {
    //   if(!this.phone) {
    //     this.$message({
    //       showClose: true,
    //       duration: 2000,
    //       message: '请输入手机号',
    //       type: 'warning'
    //     });
    //     return false
    //   }
    //   let param = {};
    //   param['id'] = 0;
    //   param['phone'] = this.phone;
    //   getFormData(getUserInfo, param).then((data)=>{
    //     let {code, msg} = data;
    //     if (code == 200) {
    //       this.userList = []
    //       this.userList.push(data.data)
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //   }).catch(()=> {
    //   })
    // },

    select(item) {
      this.userList.map(e => {
        e.check = false
      })
      item.check = !item.check
      item.userId = item.id
      this.$emit('confirm', item)
    }

  },
  mounted() {
    this.getUserList()
  }
}
</script>

<style scoped>
.user-list {
  margin-top: 12px;
}
.user-list-item {
  padding: 20px 24px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 12px;
  /*background-color: #f6f6f6;*/
  display: flex;
  align-items: center;
  cursor: pointer;
}
.active {
  border: 1px solid #409eff;
  /*background-color: #f5f7fa;*/
}
.user-list-item:hover {
  background-color: #f5f7fa;
}
.item-top {
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*padding-bottom: 16px;*/
  /*margin-bottom: 12px;*/
  /*border-bottom: 1px solid #ebeef5;*/
  width: 180px;
  margin-right: 40px;
  border-right: 1px solid #ebeef5;
}
.item-top-name {
  /*font-weight: bolder;*/
  margin-bottom: 6px;
}
.item-top-phone {
  color: #409eff;
}
.item-pet {
  display: flex;
  align-items: center;
  margin: 2px;
  /*margin-bottom: 6px;*/
}
.pointer {
  width: 5px;
  height: 5px;
  border-radius: 4px;
  background-color: #409eff;
  margin-right: 12px;
}
.noPet {
  color: #bbbbbb;
  display: flex;
  align-items: center;
}
.noPet .pointer {
  background-color: #bbbbbb;
}
</style>
